"use client";

import React from "react";
import { Building2, House as Home, Wrench, Leaf, MapPin, Mail } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const responsibilities = [{
  title: "Commercial Air Conditioning",
  description: "Scalable climate control systems designed for offices, retail spaces, and industrial facilities across Sussex and Surrey.",
  icon: Building2
}, {
  title: "Domestic Climate Control",
  description: "Whisper-quiet, energy-efficient cooling and heating solutions tailored for modern homes and living spaces.",
  icon: Home
}, {
  title: "Maintenance & Servicing",
  description: "Comprehensive preventative maintenance programs to ensure optimal performance and longevity of your HVAC assets.",
  icon: Wrench
}, {
  title: "Energy Efficient Solutions",
  description: "Eco-friendly installations focused on reducing carbon footprint and lowering operational energy costs.",
  icon: Leaf
}];
export default function ContactSplit() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="industrialcontactsplit" className="bg-background text-foreground overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[800px]">
        
        <div ref={leftRef} className={`p-8 md:p-16 lg:p-24 flex flex-col justify-center transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <div className="max-w-xl mx-auto lg:mx-0 w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 text-primary text-sm font-medium mb-6">
              <Wrench className="size-4" />
              <span>Coastline Airconditioning Services</span>
            </div>
            
            <h3 className="text-3xl md:text-4xl font-default font-bold mb-4 text-foreground">
              Our Responsibilities
            </h3>
            <p className="text-muted-foreground mb-12 text-lg">
              Delivering high-quality air conditioning and climate control systems with precision and reliability across Sussex and Surrey.
            </p>

            <div className="space-y-8">
              {responsibilities.map((item, i) => <div key={i} data-index={i} className="flex gap-4 group">
                  <div className="shrink-0 mt-1">
                    <div className="size-12 rounded-md bg-muted flex items-center justify-center border border-border group-hover:border-primary/50 group-hover:bg-primary/5 transition-colors duration-300">
                      <item.icon className="size-6 text-primary" />
                    </div>
                  </div>
                  <div>
                    <h4 className="text-xl font-default font-semibold mb-2 text-foreground group-hover:text-primary transition-colors duration-300">
                      {item.title}
                    </h4>
                    <p className="text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-16 p-6 rounded-lg bg-muted/50 border border-border shadow-sm">
              <h4 className="text-lg font-semibold mb-6 flex items-center gap-2">
                <Building2 className="size-5 text-primary" />
                Contact Details
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="mt-1">
                    <Building2 className="size-4 text-muted-foreground" />
                  </div>
                  <div>
                    <p className="font-medium text-foreground">Coastline Air Conditioning Services</p>
                    <p className="text-sm text-muted-foreground">Professional Climate Solutions</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="mt-1">
                    <MapPin className="size-4 text-muted-foreground" />
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      Serving Sussex and Surrey<br />
                      United Kingdom
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="mt-1">
                    <Mail className="size-4 text-muted-foreground" />
                  </div>
                  <div>
                    <Link to="mailto:info@coastline-services.co.uk" className="text-sm text-primary hover:underline">
                      info@coastline-services.co.uk
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref={rightRef} className={`p-8 md:p-16 lg:p-24 bg-muted/30 flex flex-col justify-center transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
          <div className="max-w-xl mx-auto lg:mx-0 w-full">
            <div className="mb-8">
              <h3 className="text-2xl md:text-3xl font-default font-bold mb-2 text-foreground">Get in Touch</h3>
              <p className="text-muted-foreground">Our team is ready to assist you with your climate control needs. Reach out via the contact details provided or visit our main contact page.</p>
            </div>
          </div>
        </div>

      </div>
    </section>;
}